import React, { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import { FieldArray as FFieldArray } from 'react-final-form-arrays';
import { Tooltip, Avatar, Button, Row } from 'antd';
import { EditClassStudentsListDrawer } from './EditClassStudentsListDrawer';
import { UserAvatar } from '../../../users/UserAvatar';
import { FormattedMessage } from 'react-intl';

const StyledEditClassStudentsListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ withMarginBottom }) =>
    withMarginBottom ? '35px' : '15px'};
  align-items: flex-start;

  @media (min-width: 1200px) {
    margin-bottom: ${({ withMarginBottom }) =>
    withMarginBottom ? '35px' : '0px'};
  }

  & .students-list__title {
    display: inline-block;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #262626;
    margin-bottom: 15px;
  }

  & .students-list__placeholder {
    color: #bfbfbf;
    user-select: none;
  }
`;

const StyledButton = styled(Button)`
  background-color: #5bbcbd;
  border: none;
  border-radius: 10px;
  font-weight: bolder;
  color: #fff;
  height: 50px;
  padding: 0 17px;
  min-width: 100px;
  margin-top: 20px;

  &:hover,
  &:focus {
    background-color: #60e4e5;
    border: none;
    color: #fff;
  }
`;

export const EditClassStudentsList = ({
  allStudents = [],
  currentClassStudents = [],
  withMarginBottom
}) => {
  const [visible, setVisible] = useState(false);
  const showDrawer = useCallback(() => setVisible(true), []);
  const onClose = useCallback(() => setVisible(false), []);

  const renderedStudentsButtonText = useMemo(
    () =>
      currentClassStudents && currentClassStudents?.length > 0
        ? <FormattedMessage id="edit-class-dashboard.main.add-remove-student-button"/>
        : <FormattedMessage id="edit-class-dashboard.main.add-student-button"/>[currentClassStudents]
  );

  return (
    <StyledEditClassStudentsListContainer withMarginBottom={withMarginBottom}>
      <small className='students-list__title'><FormattedMessage id="edit-class-dashboard.main.group-management.students-subTitle"/></small>
      <FFieldArray name='students'>
        {({ fields }) => (
          <>
            <Avatar.Group
              maxCount={4}
              size={54}
              maxStyle={{
                color: '#fff',
                backgroundColor: '#E5A84F',
                border: 0
              }}
            >
              {fields.value?.map((student) => (
                <Tooltip
                  key={student.id}
                  title={`${student?.firstName} ${student?.lastName}`}
                >
                  <UserAvatar user={student} />
                </Tooltip>
              ))}
              {(!fields.value || fields.value?.length === 0) && (
                <span className='students-list__placeholder'>
                  <FormattedMessage id="edit-class-dashboard.empyState.addStudents"/>
                </span>
              )}
            </Avatar.Group>
            <EditClassStudentsListDrawer
              allStudents={allStudents}
              currentClassStudents={fields.value}
              onClose={onClose}
              visible={visible}
              remove={fields.remove}
              push={fields.push}
            />
          </>
        )}
      </FFieldArray>
      <Row style={{ gap: 30 }}>
        <StyledButton onClick={showDrawer}>
          {renderedStudentsButtonText}
        </StyledButton>
      </Row>
    </StyledEditClassStudentsListContainer>
  );
};
